import React from "react";
import { getValue } from "@utils/lodash";

function MoreSubheaderSvgComponent(props: any) {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" id="more_vert_black_24dp" width="32" height="32" viewBox="0 0  32 32">
        <path id="Path_11316" data-name="Path 11316" d="M0,0H24V24H0Z" fill="none"/>
        <path id="Path_11317" data-name="Path 11317" d="M12,8a2,2,0,1,0-2-2A2.006,2.006,0,0,0,12,8Zm0,2a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Zm0,6a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,16Z" fill="#5f6368"/>
    </svg>
    </>
  );
}

export default MoreSubheaderSvgComponent;
